module.exports = __webpack_public_path__ + "static/logo-horizontal-white-small-e89c6f8ea4970ac043420ebc2a43f21c.png";